module.exports = __webpack_public_path__ + "img/bg-left-diamond-2.aabdef0.png";